import React from "react";
import { Label } from "../../ui/label";
import { Separator } from "../../ui/separator";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../ui/select";
import { Car } from "lucide-react";

const VehicleSection = ({ formData, setFormData, vehicleData }) => {
  return (
    <>
      <Separator className="bg-theme-hover" />
      <div className="space-y-3 sm:space-y-4">
        <div className="flex items-center gap-2 text-[#FFCC00]">
          <Car className="w-4 h-4" />
          <span className="text-sm font-medium">Vehicle Information</span>
        </div>
        <div className="grid grid-cols-3 gap-3">
          <div className="space-y-1.5">
            <Label className="text-muted-foreground text-xs">Year</Label>
            <Select value={formData.vehicle_year} onValueChange={(val) => setFormData(prev => ({ ...prev, vehicle_year: val }))}>
              <SelectTrigger className="input-glass" data-testid="vehicle-year-select">
                <SelectValue placeholder="Year" />
              </SelectTrigger>
              <SelectContent>
                {vehicleData.years?.map((year) => (
                  <SelectItem key={year} value={String(year)}>{year}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label className="text-muted-foreground text-xs">Make</Label>
            <Select value={formData.vehicle_make} onValueChange={(val) => setFormData(prev => ({ ...prev, vehicle_make: val, vehicle_model: "" }))}>
              <SelectTrigger className="input-glass" data-testid="vehicle-make-select">
                <SelectValue placeholder="Make" />
              </SelectTrigger>
              <SelectContent>
                {vehicleData.makes?.map((make) => (
                  <SelectItem key={make} value={make}>{make}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label className="text-muted-foreground text-xs">Model</Label>
            <Select value={formData.vehicle_model} onValueChange={(val) => setFormData(prev => ({ ...prev, vehicle_model: val }))} disabled={!formData.vehicle_make}>
              <SelectTrigger className="input-glass" data-testid="vehicle-model-select">
                <SelectValue placeholder="Model" />
              </SelectTrigger>
              <SelectContent>
                {(vehicleData.models_by_make?.[formData.vehicle_make] || []).map((model) => (
                  <SelectItem key={model} value={model}>{model}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleSection;
